<template>
  <div class="cooperation-case ">
    <div class="row">
      <div class="col-md-12 introduce-banner flex-center">
        <div class="introduce-banner-bg"></div>
        <div class="flex-center introduce-banner-img">
          <img   src="@static/img/cooperation_case/banner-center.png"  alt="">
        </div>
      </div>
    </div>
    <div class="flex-center introduce-img">
      <img   src="@static/img/cooperation_case/img1.png"  alt="">
    </div>
    <div class="flex-center introduce-img">
      <img   src="@static/img/cooperation_case/img2.png"  alt="">
    </div>
    <div class="flex-center introduce-img">
      <img   src="@static/img/cooperation_case/img3.png"  alt="">
    </div>
    <div class="flex-center introduce-img">
      <img   src="@static/img/cooperation_case/img4.png"  alt="">
    </div>

  </div>
</template>
<script>
export default {
  name: 'CooperationCase',
  data () {
    return {
      msg: 'cooperationCase'
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-introduce{
}
.introduce-banner{

  position: relative;
  height: 760px;
  width: 100%;
}
.introduce-banner-bg{
 position: absolute;
 top: 0;
 left: 0;
 width: 100%;
  height: 560px;
  background: #0CBEB4;
}
.introduce-banner-img{
  position: absolute;
 top: 0;
 left: 0;
  width: 100%;
height: 760px;
}
.introduce-banner-img>img{
  max-width: 1260px;
  width: 100%;
  height: 100%;
}
.introduce-img{
  width: 100%;
  height: 630px;
  margin-bottom: 150px;
}
.introduce-img>img{
  max-width: 1440px;
  width: 100%;
  height: 100%;
}
.banner-picture {
    height: 627px;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    background-position: center 0;
}

</style>



// WEBPACK FOOTER //
// src/components/CooperationCase.vue